// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Scalar from "../../core/Scalar.res.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query ProductQuery($cku: CKU!, $filterBy: InputProductsByVariantCkuQueryFilter, $productVariantsFilterBy: InputProductVariantsQueryFilter)  {\nproductsByVariantCku(cku: $cku, first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedStatus  \narchivedAt  \nname  \nformattedDescription  \nformattedOrigin  \ncategory  {\n__typename  \nid  \nformattedName  \n}\n\ntax  {\n__typename  \nvalue  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\ninternalNote  \nvariants(first: 50, filterBy: $productVariantsFilterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \ncku  \nid  \nname  \narchivedAt  \nshop  {\n__typename  \nname  \n}\n\nformattedStatus  \nformattedPurchasedPrice  \npurchasedPrice  \ncapacityUnit  \nbulk  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nvariantPrices  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nvalueIncludingTax  \nvalueExcludingTax  \nprice  {\n__typename  \nname  \nenableByDefault  \ntaxIncluded  \n}\n\n}\n\n}\n\n}\n\nstock  {\n__typename  \nformattedQuantity  \nstate  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  return {
    productsByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.formattedStatus;
        let tmp;
        if (value$2 == null) {
          tmp = undefined;
        } else {
          let tmp$1;
          switch (value$2) {
            case "ACTIVE" :
              tmp$1 = "ACTIVE";
              break;
            case "ARCHIVED" :
              tmp$1 = "ARCHIVED";
              break;
            case "INACTIVE" :
              tmp$1 = "INACTIVE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = tmp$1;
        }
        let value$3 = value$1.archivedAt;
        let value$4 = value$1.formattedDescription;
        let value$5 = value$1.category;
        let value$6 = value$1.tax;
        let value$7 = value$1.shop;
        let value$8 = value$1.internalNote;
        let value$9 = value$1.variants;
        let value$10 = value$9.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedStatus: tmp,
            archivedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined,
            name: value$1.name,
            formattedDescription: !(value$4 == null) ? value$4 : undefined,
            formattedOrigin: value$1.formattedOrigin,
            category: !(value$5 == null) ? ({
                __typename: value$5.__typename,
                id: value$5.id,
                formattedName: value$5.formattedName
              }) : undefined,
            tax: {
              __typename: value$6.__typename,
              value: value$6.value
            },
            shop: {
              __typename: value$7.__typename,
              id: value$7.id,
              name: value$7.name
            },
            internalNote: !(value$8 == null) ? Scalar.Text.parse(value$8) : undefined,
            variants: {
              __typename: value$9.__typename,
              edges: value$10.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.archivedAt;
                let value$3 = value$1.shop;
                let value$4 = value$1.formattedStatus;
                let tmp;
                switch (value$4) {
                  case "ACTIVE" :
                    tmp = "ACTIVE";
                    break;
                  case "ARCHIVED" :
                    tmp = "ARCHIVED";
                    break;
                  case "INACTIVE" :
                    tmp = "INACTIVE";
                    break;
                  case "VARIABLE" :
                    tmp = "VARIABLE";
                    break;
                  default:
                    throw {
                      RE_EXN_ID: "Not_found",
                      Error: new Error()
                    };
                }
                let value$5 = value$1.formattedPurchasedPrice;
                let value$6 = value$1.purchasedPrice;
                let value$7 = value$1.capacityUnit;
                let value$8 = value$1.bulk;
                let value$9 = value$1.maxStockThreshold;
                let value$10 = value$1.minStockThreshold;
                let value$11 = value$1.stockOrderTriggerThreshold;
                let value$12 = value$1.variantPrices;
                let value$13 = value$12.edges;
                let value$14 = value$1.stock;
                let value$15 = value$14.formattedQuantity;
                let value$16 = value$14.state;
                let tmp$1;
                if (value$16 == null) {
                  tmp$1 = undefined;
                } else {
                  let tmp$2;
                  switch (value$16) {
                    case "ALERT" :
                      tmp$2 = "ALERT";
                      break;
                    case "DANGER" :
                      tmp$2 = "DANGER";
                      break;
                    case "OK" :
                      tmp$2 = "OK";
                      break;
                    default:
                      throw {
                        RE_EXN_ID: "Not_found",
                        Error: new Error()
                      };
                  }
                  tmp$1 = tmp$2;
                }
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    cku: Scalar.CKU.parse(value$1.cku),
                    id: value$1.id,
                    name: value$1.name,
                    archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
                    shop: {
                      __typename: value$3.__typename,
                      name: value$3.name
                    },
                    formattedStatus: tmp,
                    formattedPurchasedPrice: !(value$5 == null) ? value$5 : undefined,
                    purchasedPrice: !(value$6 == null) ? value$6 : undefined,
                    capacityUnit: !(value$7 == null) ? value$7 : undefined,
                    bulk: !(value$8 == null) ? value$8 : undefined,
                    maxStockThreshold: !(value$9 == null) ? value$9 : undefined,
                    minStockThreshold: !(value$10 == null) ? value$10 : undefined,
                    stockOrderTriggerThreshold: !(value$11 == null) ? value$11 : undefined,
                    variantPrices: {
                      __typename: value$12.__typename,
                      edges: value$13.map(value => {
                        let value$1 = value.node;
                        let value$2 = value$1.price;
                        return {
                          __typename: value.__typename,
                          node: {
                            __typename: value$1.__typename,
                            valueIncludingTax: value$1.valueIncludingTax,
                            valueExcludingTax: value$1.valueExcludingTax,
                            price: !(value$2 == null) ? ({
                                __typename: value$2.__typename,
                                name: value$2.name,
                                enableByDefault: value$2.enableByDefault,
                                taxIncluded: value$2.taxIncluded
                              }) : undefined
                          }
                        };
                      })
                    },
                    stock: {
                      __typename: value$14.__typename,
                      formattedQuantity: !(value$15 == null) ? value$15 : undefined,
                      state: tmp$1
                    }
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variants;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.stock;
      let value$3 = value$2.state;
      let state = value$3 !== undefined ? (
          value$3 === "OK" ? "OK" : (
              value$3 === "ALERT" ? "ALERT" : "DANGER"
            )
        ) : null;
      let value$4 = value$2.formattedQuantity;
      let formattedQuantity = value$4 !== undefined ? value$4 : null;
      let value$5 = value$2.__typename;
      let stock = {
        __typename: value$5,
        formattedQuantity: formattedQuantity,
        state: state
      };
      let value$6 = value$1.variantPrices;
      let value$7 = value$6.edges;
      let edges = value$7.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.price;
        let price;
        if (value$2 !== undefined) {
          let value$3 = value$2.taxIncluded;
          let value$4 = value$2.enableByDefault;
          let value$5 = value$2.name;
          let value$6 = value$2.__typename;
          price = {
            __typename: value$6,
            name: value$5,
            enableByDefault: value$4,
            taxIncluded: value$3
          };
        } else {
          price = null;
        }
        let value$7 = value$1.valueExcludingTax;
        let value$8 = value$1.valueIncludingTax;
        let value$9 = value$1.__typename;
        let node = {
          __typename: value$9,
          valueIncludingTax: value$8,
          valueExcludingTax: value$7,
          price: price
        };
        let value$10 = value.__typename;
        return {
          __typename: value$10,
          node: node
        };
      });
      let value$8 = value$6.__typename;
      let variantPrices = {
        __typename: value$8,
        edges: edges
      };
      let value$9 = value$1.stockOrderTriggerThreshold;
      let stockOrderTriggerThreshold = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.minStockThreshold;
      let minStockThreshold = value$10 !== undefined ? value$10 : null;
      let value$11 = value$1.maxStockThreshold;
      let maxStockThreshold = value$11 !== undefined ? value$11 : null;
      let value$12 = value$1.bulk;
      let bulk = value$12 !== undefined ? value$12 : null;
      let value$13 = value$1.capacityUnit;
      let capacityUnit = value$13 !== undefined ? value$13 : null;
      let value$14 = value$1.purchasedPrice;
      let purchasedPrice = value$14 !== undefined ? value$14 : null;
      let value$15 = value$1.formattedPurchasedPrice;
      let formattedPurchasedPrice = value$15 !== undefined ? value$15 : null;
      let value$16 = value$1.formattedStatus;
      let formattedStatus = value$16 === "INACTIVE" ? "INACTIVE" : (
          value$16 === "ARCHIVED" ? "ARCHIVED" : (
              value$16 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
            )
        );
      let value$17 = value$1.shop;
      let value$18 = value$17.name;
      let value$19 = value$17.__typename;
      let shop = {
        __typename: value$19,
        name: value$18
      };
      let value$20 = value$1.archivedAt;
      let archivedAt = value$20 !== undefined ? Scalar.Datetime.serialize(value$20) : null;
      let value$21 = value$1.name;
      let value$22 = value$1.id;
      let value$23 = value$1.cku;
      let value$24 = Scalar.CKU.serialize(value$23);
      let value$25 = value$1.__typename;
      let node = {
        __typename: value$25,
        cku: value$24,
        id: value$22,
        name: value$21,
        archivedAt: archivedAt,
        shop: shop,
        formattedStatus: formattedStatus,
        formattedPurchasedPrice: formattedPurchasedPrice,
        purchasedPrice: purchasedPrice,
        capacityUnit: capacityUnit,
        bulk: bulk,
        maxStockThreshold: maxStockThreshold,
        minStockThreshold: minStockThreshold,
        stockOrderTriggerThreshold: stockOrderTriggerThreshold,
        variantPrices: variantPrices,
        stock: stock
      };
      let value$26 = value.__typename;
      return {
        __typename: value$26,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variants = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.internalNote;
    let internalNote = value$5 !== undefined ? Scalar.Text.serialize(value$5) : null;
    let value$6 = value$1.shop;
    let value$7 = value$6.name;
    let value$8 = value$6.id;
    let value$9 = value$6.__typename;
    let shop = {
      __typename: value$9,
      id: value$8,
      name: value$7
    };
    let value$10 = value$1.tax;
    let value$11 = value$10.value;
    let value$12 = value$10.__typename;
    let tax = {
      __typename: value$12,
      value: value$11
    };
    let value$13 = value$1.category;
    let category;
    if (value$13 !== undefined) {
      let value$14 = value$13.formattedName;
      let value$15 = value$13.id;
      let value$16 = value$13.__typename;
      category = {
        __typename: value$16,
        id: value$15,
        formattedName: value$14
      };
    } else {
      category = null;
    }
    let value$17 = value$1.formattedOrigin;
    let value$18 = value$1.formattedDescription;
    let formattedDescription = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.name;
    let value$20 = value$1.archivedAt;
    let archivedAt = value$20 !== undefined ? Scalar.Datetime.serialize(value$20) : null;
    let value$21 = value$1.formattedStatus;
    let formattedStatus = value$21 !== undefined ? (
        value$21 === "ARCHIVED" ? "ARCHIVED" : (
            value$21 === "ACTIVE" ? "ACTIVE" : "INACTIVE"
          )
      ) : null;
    let value$22 = value$1.id;
    let value$23 = value$1.__typename;
    let node = {
      __typename: value$23,
      id: value$22,
      formattedStatus: formattedStatus,
      archivedAt: archivedAt,
      name: value$19,
      formattedDescription: formattedDescription,
      formattedOrigin: value$17,
      category: category,
      tax: tax,
      shop: shop,
      internalNote: internalNote,
      variants: variants
    };
    let value$24 = value.__typename;
    return {
      __typename: value$24,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let productsByVariantCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    productsByVariantCku: productsByVariantCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputProductsByVariantCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectInputProductVariantsQueryFilter(inp) {
  let a = inp.archived;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  let a$1 = inp.productVariantsFilterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputProductsByVariantCkuQueryFilter(a) : undefined,
    productVariantsFilterBy: a$1 !== undefined ? serializeInputObjectInputProductVariantsQueryFilter(a$1) : undefined
  };
}

function makeVariables(cku, filterBy, productVariantsFilterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy,
    productVariantsFilterBy: productVariantsFilterBy
  };
}

function makeInputObjectInputProductsByVariantCkuQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectInputProductVariantsQueryFilter(archived, param) {
  return {
    archived: archived
  };
}

let ProductQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectInputProductVariantsQueryFilter: serializeInputObjectInputProductVariantsQueryFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectInputProductVariantsQueryFilter: makeInputObjectInputProductVariantsQueryFilter
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let ProductQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductQuery_use = include.use;

let ProductQuery_useLazy = include.useLazy;

let ProductQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductQuery = {
  ProductQuery_inner: ProductQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectInputProductVariantsQueryFilter: serializeInputObjectInputProductVariantsQueryFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectInputProductVariantsQueryFilter: makeInputObjectInputProductVariantsQueryFilter,
  refetchQueryDescription: ProductQuery_refetchQueryDescription,
  use: ProductQuery_use,
  useLazy: ProductQuery_useLazy,
  useLazyWithVariables: ProductQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query ProductQuery($cku: CKU!)  {\nproductsByVariantCku(cku: $cku, first: 50, filterBy: {archived: INCLUDED})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  return {
    productsByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      shop: shop
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let productsByVariantCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    productsByVariantCku: productsByVariantCku
  };
}

function serializeVariables$1(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables$1(cku, param) {
  return {
    cku: cku
  };
}

let ProductShopsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let ProductShopsQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let ProductShopsQuery_use = include$1.use;

let ProductShopsQuery_useLazy = include$1.useLazy;

let ProductShopsQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let ProductShopsQuery = {
  ProductShopsQuery_inner: ProductShopsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: ProductShopsQuery_refetchQueryDescription,
  use: ProductShopsQuery_use,
  useLazy: ProductShopsQuery_useLazy,
  useLazyWithVariables: ProductShopsQuery_useLazyWithVariables
};

export {
  ProductQuery,
  ProductShopsQuery,
}
/* query Not a pure module */
